// Word-level diff using an LCS table. Returns an ordered list of segments:
//   { type: "unchanged" | "added" | "removed", text }
// Used to render Word-style track-changes (removed = strikethrough, added = underline).
export const computeWordDiff = (oldText = "", newText = "") => {
  const oldWords = (oldText || "").split(/\s+/).filter(Boolean);
  const newWords = (newText || "").split(/\s+/).filter(Boolean);
  const m = oldWords.length;
  const n = newWords.length;

  // Build LCS table
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      dp[i][j] =
        oldWords[i - 1] === newWords[j - 1]
          ? dp[i - 1][j - 1] + 1
          : Math.max(dp[i - 1][j], dp[i][j - 1]);
    }
  }

  // Backtrack
  const ops = [];
  let i = m,
    j = n;
  while (i > 0 || j > 0) {
    if (i > 0 && j > 0 && oldWords[i - 1] === newWords[j - 1]) {
      ops.push({ type: "unchanged", text: oldWords[i - 1] });
      i--;
      j--;
    } else if (j > 0 && (i === 0 || dp[i][j - 1] >= dp[i - 1][j])) {
      ops.push({ type: "added", text: newWords[j - 1] });
      j--;
    } else {
      ops.push({ type: "removed", text: oldWords[i - 1] });
      i--;
    }
  }
  return ops.reverse();
};
